import './main.less';

import withPageContainer from '../shared/page-container/with-page-container';
import withIntl from '../shared/intl-hoc';

import { enum as permissions } from '../../../../../enums/admin-permissions';

const navigation = [
	{
		href: '/blog/articles',
		name: 'Articles',
		permission: null
	},
	{
		href: '/blog/article-images',
		name: 'Article images',
		permission: null
	},
	{
		href: '/blog/article-tags',
		name: 'Article tags',
		permission: null
	},
	{
		href: '/blog/article-comments',
		name: 'Article comments',
		permission: null
	}
];

export default Main => withPageContainer(withIntl(Main), {
	name: 'Blog',
	tabs: navigation,
	permission: permissions.blog
});


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/blog/wrap-main.js